<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" fill="#303237" />
    <rect x="6" y="6" width="16" height="16" stroke="currentColor" stroke-width="1.5" />
    <rect x="9" y="15" width="5" height="1.5" fill="currentColor" />
    <rect x="9" y="10" width="7" height="1.5" fill="currentColor" />
  </svg>
</template>
<script lang="ts" setup></script>
